const actionPrefix = "FACE_CAPTURE_";

export const PREVIEW = actionPrefix + "PREVIEW";
export const RETRY = actionPrefix + "RETRY";

export function preview(payload) {
  return {
    type: PREVIEW,
    payload
  }
}

export function retry() {
  return { type: RETRY }
}
